import { Modal } from 'component/Modal'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { demo } from 'page/catalog/store/CatalogStore'
import { CreateStep } from 'page/catalog/UserModal/step/CreateStep'
import { EditStep } from 'page/catalog/UserModal/step/EditStep'
import { FailStep } from 'page/catalog/UserModal/step/FailStep'
import { SearchStep } from 'page/catalog/UserModal/step/SearchStep'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'
import { ReactElement } from 'react'
import { ui } from 'store/home/ui/HomeUiStore'
import { assertNever } from 'util/assert'

function title(): string {
  const be = demo.it.by_email
  const bc = demo.it.by_card
  const { step, creating } = userModal.it
  switch (step) {
    case 'search':
      return be ? i18n('SearchByEmail') : bc ? i18n('SearchByClientId') : i18n('SearchByPhone')
    case 'create':
    case 'edit':
    case 'fail':
      return creating ? i18n('CustomerAdding') : i18n('CustomerEditing')
    default:
      assertNever(step)
  }
}

function content(): ReactElement {
  const { step } = userModal.it
  switch (step) {
    case 'search':
      return <SearchStep />
    case 'create':
      return <CreateStep />
    case 'fail':
      return <FailStep />
    case 'edit':
      return <EditStep />
    default:
      assertNever(step)
  }
}

export const UserModal = observer(() => {
  const { small } = ui.window
  const width = small ? undefined : 400

  const onClose = useLatestCallback(() => {
    userModal.close()
  })

  return (
    <Modal open={true} banner={small} white title={title()} width={width} onCancel={onClose}>
      {content()}
    </Modal>
  )
})
